import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GenericForm from '../components/GenericForm';
import { get_donor_by_id, update_donor } from '../api/donor_api';
import { isValidIsraeliID, isOnlyNumbers, isValidPhoneNumber, isValidEmail, isValidPassport } from '../utils/validationId';

const UpdateDonor = () => {
    const { donor_id } = useParams();

    const navigate = useNavigate();
    const [donor, setDonor] = useState(null);

    useEffect(() => {
        const fetchDonor = async () => {
            try {
                const data = await get_donor_by_id(donor_id);
                setDonor(data);
            } catch (err) {
                console.error('טעינת תורם נכשלה', err);
                alert('טעינת תורם נכשלה');
                navigate('/donors');
            }
        };
        fetchDonor();
    }, [donor_id, navigate]);

    if (!donor) return <p>טוען...</p>;

    const handleSubmit = async (formData) => {
        const type = formData.id_type;
        const id = donor?.id;
        if (!id) {
            alert("לא ניתן לעדכן תורם – מזהה לא נמצא");
            return;
        }

        const idValue = formData.donor_id || formData.id;

        // ולידציה לפי סוג המזהה שנבחר
        if (type === 'passport') {
            if (!isValidPassport(idValue)) {
                alert("מספר דרכון לא תקין.");
                return;
            }
        }
        // ה-else מוודא שולידציית ת"ז תרוץ רק אם זה לא דרכון
        else {
            if (!idValue || !isOnlyNumbers(idValue) || !isValidIsraeliID(idValue)) {
                alert("מספר ת.ז. לא תקין");
                return;
            }
        }

       

        if (formData.phone && !isValidPhoneNumber(formData.phone)) {
            alert("מספר פלאפון לא תקין");
            return;
        }

        if (formData.email && formData.email.trim() !== '') {
            if (!isValidEmail(formData.email)) {
                alert("אימייל לא תקין");
                return;
            }
        }

        try {
            await update_donor(formData);
            alert('עודכן בהצלחה!');
            navigate(`/donors/${id}`);
        } catch (err) {
            console.error('Error updating donor:', err);
            alert('עדכון נכשל');
        }
    };

    return (
        <>
           <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <h2 style={{ color: "#150F6B", textAlign: "center" }}>עדכון תורם</h2>
            </div>
            <GenericForm
                key={donor.id || donor.donor_id}
                mode="edit"
                kind="donor"
                initialData={donor}
                onSubmit={handleSubmit}
            />
        </>
    );
};

export default UpdateDonor;
